'use client'

import { useEffect, useState } from 'react'

/**
 * Returns `value` debounced by `delayMs`. When `delayMs` is 0 or negative the
 * value passes through immediately — callers can toggle debouncing on/off
 * without branching.
 */
export function useDebouncedValue<T>(value: T, delayMs = 0): T {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        if (delayMs <= 0) return
        const timer = setTimeout(() => setDebounced(value), delayMs)
        return () => clearTimeout(timer)
    }, [value, delayMs])

    return delayMs <= 0 ? value : debounced
}
